import _classCallCheck from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { __awaiter } from "tslib";
import { optionsFromArguments } from "../../core/util/Defaults";
import { noOp, readOnly } from "../../core/util/Interface";
import { Signal } from "../../signal/Signal";
import { Source } from "../Source";
import { Oscillator } from "./Oscillator";
import { generateWaveform } from "./OscillatorInterface";
import { assertRange } from "../../core/util/Debug";
/**
 * FatOscillator is an array of oscillators with detune spread between the oscillators
 * @example
 * const fatOsc = new Tone.FatOscillator("Ab3", "sawtooth", 40).toDestination().start();
 * @category Source
 */

export var FatOscillator = /*#__PURE__*/function (_Source) {
  _inherits(FatOscillator, _Source);

  var _super = _createSuper(FatOscillator);

  function FatOscillator() {
    var _this;

    _classCallCheck(this, FatOscillator);

    _this = _super.call(this, optionsFromArguments(FatOscillator.getDefaults(), arguments, ["frequency", "type", "spread"]));
    _this.name = "FatOscillator";
    /**
     * The array of oscillators
     */

    _this._oscillators = [];
    var options = optionsFromArguments(FatOscillator.getDefaults(), arguments, ["frequency", "type", "spread"]);
    _this.frequency = new Signal({
      context: _this.context,
      units: "frequency",
      value: options.frequency
    });
    _this.detune = new Signal({
      context: _this.context,
      units: "cents",
      value: options.detune
    });
    _this._spread = options.spread;
    _this._type = options.type;
    _this._phase = options.phase;
    _this._partials = options.partials;
    _this._partialCount = options.partialCount; // set the count initially

    _this.count = options.count;
    readOnly(_assertThisInitialized(_this), ["frequency", "detune"]);
    return _this;
  }

  _createClass(FatOscillator, [{
    key: "_start",
    value:
    /**
     * start the oscillator
     */
    function _start(time) {
      time = this.toSeconds(time);

      this._forEach(function (osc) {
        return osc.start(time);
      });
    }
    /**
     * stop the oscillator
     */

  }, {
    key: "_stop",
    value: function _stop(time) {
      time = this.toSeconds(time);

      this._forEach(function (osc) {
        return osc.stop(time);
      });
    }
  }, {
    key: "_restart",
    value: function _restart(time) {
      this._forEach(function (osc) {
        return osc.restart(time);
      });
    }
    /**
     * Iterate over all of the oscillators
     */

  }, {
    key: "_forEach",
    value: function _forEach(iterator) {
      for (var i = 0; i < this._oscillators.length; i++) {
        iterator(this._oscillators[i], i);
      }
    }
    /**
     * The type of the oscillator
     */

  }, {
    key: "type",
    get: function get() {
      return this._type;
    },
    set: function set(type) {
      this._type = type;

      this._forEach(function (osc) {
        return osc.type = type;
      });
    }
    /**
     * The detune spread between the oscillators. If "count" is
     * set to 3 oscillators and the "spread" is set to 40,
     * the three oscillators would be detuned like this: [-20, 0, 20]
     * for a total detune spread of 40 cents.
     * @example
     * const fatOsc = new Tone.FatOscillator().toDestination().start();
     * fatOsc.spread = 70;
     */

  }, {
    key: "spread",
    get: function get() {
      return this._spread;
    },
    set: function set(spread) {
      this._spread = spread;

      if (this._oscillators.length > 1) {
        var start = -spread / 2;
        var step = spread / (this._oscillators.length - 1);

        this._forEach(function (osc, i) {
          return osc.detune.value = start + step * i;
        });
      }
    }
    /**
     * The number of detuned oscillators. Must be an integer greater than 1.
     * @example
     * const fatOsc = new Tone.FatOscillator("C#3", "sawtooth").toDestination().start();
     * // use 4 sawtooth oscillators
     * fatOsc.count = 4;
     */

  }, {
    key: "count",
    get: function get() {
      return this._oscillators.length;
    },
    set: function set(count) {
      var _this2 = this;

      assertRange(count, 1);

      if (this._oscillators.length !== count) {
        // dispose the previous oscillators
        this._forEach(function (osc) {
          return osc.dispose();
        });

        this._oscillators = [];

        for (var i = 0; i < count; i++) {
          var osc = new Oscillator({
            context: this.context,
            volume: -6 - count * 1.1,
            type: this._type,
            phase: this._phase + i / count * 360,
            partialCount: this._partialCount,
            onstop: i === 0 ? function () {
              return _this2.onstop(_this2);
            } : noOp
          });

          if (this.type === "custom") {
            osc.partials = this._partials;
          }

          this.frequency.connect(osc.frequency);
          this.detune.connect(osc.detune);
          osc.detune.overridden = false;
          osc.connect(this.output);
          this._oscillators[i] = osc;
        } // set the spread


        this.spread = this._spread;

        if (this.state === "started") {
          this._forEach(function (osc) {
            return osc.start();
          });
        }
      }
    }
  }, {
    key: "phase",
    get: function get() {
      return this._phase;
    },
    set: function set(phase) {
      var _this3 = this;

      this._phase = phase;

      this._forEach(function (osc, i) {
        return osc.phase = _this3._phase + i / _this3.count * 360;
      });
    }
  }, {
    key: "baseType",
    get: function get() {
      return this._oscillators[0].baseType;
    },
    set: function set(baseType) {
      this._forEach(function (osc) {
        return osc.baseType = baseType;
      });

      this._type = this._oscillators[0].type;
    }
  }, {
    key: "partials",
    get: function get() {
      return this._oscillators[0].partials;
    },
    set: function set(partials) {
      this._partials = partials;
      this._partialCount = this._partials.length;

      if (partials.length) {
        this._type = "custom";

        this._forEach(function (osc) {
          return osc.partials = partials;
        });
      }
    }
  }, {
    key: "partialCount",
    get: function get() {
      return this._oscillators[0].partialCount;
    },
    set: function set(partialCount) {
      this._partialCount = partialCount;

      this._forEach(function (osc) {
        return osc.partialCount = partialCount;
      });

      this._type = this._oscillators[0].type;
    }
  }, {
    key: "asArray",
    value: function asArray() {
      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1024;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", generateWaveform(this, length));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Clean up.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(FatOscillator.prototype), "dispose", this).call(this);

      this.frequency.dispose();
      this.detune.dispose();

      this._forEach(function (osc) {
        return osc.dispose();
      });

      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(Oscillator.getDefaults(), {
        count: 3,
        spread: 20,
        type: "sawtooth"
      });
    }
  }]);

  return FatOscillator;
}(Source);